export type ReasonValue =
  | 'too_expensive'
  | 'not_finding_time'
  | 'not_enough_books'
  | 'content_short'
  | 'app_short'
  | 'just_trying_it'
  | 'something_else'

export type Reason = {
  value: ReasonValue
  label: string
}

export const ALL_REASONS: Reason[] = [
  {
    value: 'too_expensive',
    label: 'Too expensive for me right now',
  },
  {
    value: 'not_finding_time',
    label: "I'm not finding time to use it",
  },
  {
    value: 'not_enough_books',
    label: "I didn't find enough books I wanted",
  },
  {
    value: 'content_short',
    label: "The content quality wasn't good enough",
  },
  {
    value: 'app_short',
    label: "The app experience wasn't good enough",
  },
  {
    value: 'just_trying_it',
    label: 'I was just trying it',
  },
  { value: 'something_else', label: 'Something else' },
]
